import { AxiosInstance } from 'axios'

import { BonusPage, SlotMachineOptions } from '@/api/modules/site/site.types'
import { HttpStatusCode, NotFoundError, Success } from '@/api/results'
import { FlatpageData } from '@/types/api/api-v3/flatpage'
import { PaymentPage } from '@/types/api/api-v3/payment'

export function createSiteModule({
  axios,
  sentry,
  city,
}: {
  axios: AxiosInstance
  sentry: any
  city: string
}) {
  return {
    async fetchFlatpageData(path: string) {
      try {
        const { data } = await axios.get<FlatpageData>(`/${city}/flatpages/`, {
          params: { url: path },
        })

        return new Success(data)
      } catch (error) {
        sentry.captureException(error)
        return new Error('Что-то пошло не так')
      }
    },

    async getPopupWorking(isBasket: boolean) {
      try {
        const { data } = await axios.get(
          `/${city}/popups/?is_basket=${isBasket}`,
        )

        return new Success(data)
      } catch (error) {
        switch (error.response?.status) {
          default:
            sentry.captureException(error)
            return new Error('Что-то пошло не так')
        }
      }
    },

    async fetchPaymentPage() {
      try {
        const { data } = await axios.get<PaymentPage>(`/${city}/payment/`)

        return new Success(data)
      } catch (error) {
        sentry.captureException(error)
        return new Error('Что-то пошло не так')
      }
    },

    async fetchBonusPage() {
      try {
        const { data } = await axios.get<BonusPage>(`/${city}/bonus/`)

        return new Success(data)
      } catch (error) {
        switch (error.response?.status) {
          default:
            sentry.captureException(error)

            return new Error('Что-то пошло не так')
        }
      }
    },

    async fetchSlotMachineOptions() {
      try {
        const { data } = await axios.get<SlotMachineOptions>(
          `/${city}/slot_machine/`,
        )

        return new Success(data)
      } catch (error) {
        switch (error.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError(
              'Слот машина для города не создана или неактивна.',
            )
          default:
            sentry.captureException(error)

            return new Error('Что-то пошло не так')
        }
      }
    },
  }
}
